import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GET_COURSE_MOMENTS, DELETE_COURSE_MOMENT } from "api";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { useStyles as useStylesContentList } from "ui/styles/contentList";
import CourseMoment from "components/CourseMoment";
import Participants from "pages/participants";

const CourseMoments: React.FC = (props) => {
  let navigate = useNavigate();
  const classesContentList = useStylesContentList();
  const [selectedCourseMoment, setSelectedCourseMoment] = useState<any>(null);
  const [
    selectedCourseMomentParticipants,
    setSelectedCourseMomentParticipants,
  ] = useState<any>(null);

  // Methods.

  const editItem = (id = "skapa") => {
    navigate(`/utbildningar/${id}`);
  };

  const getActionButtons = () => {
    let buttons = [];
    if (VoAuth.ability.can("update_own_course_moments", "Cert")) {
      buttons.push("edit");
    }
    if (VoAuth.ability.can("delete_own_course_moments", "Cert")) {
      buttons.push("delete");
    }
    return buttons;
  };

  const getCustomActionButtons = (row: any) => {
    return (
      <>
        <IconButton
          className={classesContentList.actionButton}
          aria-label="participants"
          onClick={() => setSelectedCourseMomentParticipants(row)}
        >
          <PeopleAltIcon />
        </IconButton>
        <IconButton
          className={classesContentList.actionButton}
          aria-label="summary"
          onClick={() => setSelectedCourseMoment(row)}
        >
          <AssessmentIcon />
        </IconButton>
      </>
    );
  };

  return (
    <Layout>
      <EnhancedTable
        enableSearch
        className="vo-global__top-bottom-space"
        title={I18n.get.vocertCourseMoment.labels.courseMoments}
        operations={{
          category: "certCourseMoments",
          get: GET_COURSE_MOMENTS,
          delete: DELETE_COURSE_MOMENT,
        }}
        labels={{
          deleted: I18n.get.vocertCourseMoment.messages.courseMomentDeleted,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.form.labels.title, field: "title" },
          {
            title: I18n.get.form.labels.items,
            field: "items",
            width: 100,
          },
          {
            title: I18n.get.participant.labels.participants,
            field: "participantsCount",
            width: 100,
          },
          {
            title: I18n.get.form.labels.startdate,
            field: "start_date",
            width: 100,
          },
          {
            title: I18n.get.form.labels.startdate,
            field: "end_date",
            width: 100,
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
        ]}
        addItem={
          VoAuth.ability.can("create_own_course_moments", "Cert")
            ? editItem
            : undefined
        }
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        actionButtons={getActionButtons()}
        renderActionButtons={getCustomActionButtons}
      />
      <CourseMoment
        open={!!selectedCourseMoment}
        onCancel={() => setSelectedCourseMoment(null)}
        disableActions
        title={selectedCourseMoment?.title}
        item={selectedCourseMoment}
      />
      {!!selectedCourseMomentParticipants && (
        <Participants
          dialog
          dialogProps={{ open: !!selectedCourseMomentParticipants }}
          onCancel={() => setSelectedCourseMomentParticipants(false)}
          courseMoment={selectedCourseMomentParticipants}
        />
      )}
    </Layout>
  );
};

export default CourseMoments;
